import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/styles'
import { TitleList, HeroAndSearchForm, MiddlePart  } from './components'
import { useActions } from '../../actions'
import * as LanguageActions from '../../actions/language'
import { withRouter } from 'react-router-dom'
import getLangcodeFromUrl from '../../helpers/getLangcodeFromUrl'

const useStyles = makeStyles((theme) => ({
  root: { background: '#e8f1f4' },
  imageCoverContainer: {
    height: 300,
    width: '100%',
    backgroundImage:
      'url(https://s3.eu-central-1.amazonaws.com/meetingpackage.com/assets/images/NCH.jpg)',
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  },
  container: {
    maxWidth: 1280,
    width: '100%',
    marginLeft: 10,
    marginRight: 10
  },
  inImageTitleContainer: {
    marginTop: 60,
    [theme.breakpoints.down('sm')]: {
      marginTop: 90
    }
  },
  inImageTitle: {
    display: 'block',
    fontWeight: 500,
    fontSize: 36,
    lineHeight: 1.35,
    textAlign: 'center',
    color: 'white'
  },
  inImageSubtitle: {
    display: 'block',
    fontWeight: 500,
    fontSize: 20,
    lineHeight: '28px',
    color: 'white'
  },
  inputContainer: {
    marginTop: 60,
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  input: {
    background: 'white',
    height: 60,
    borderRight: '1px solid #002f3d',
    padding: '10px 15px',
    fontSize: 20,
    fontWeight: 500,
    lineHeight: '40px',
    color: '#002f3d'
  }
}))

const FrontPageBookameeting = withRouter(({ location, match, ...props }) => {
  const languageActions = useActions(LanguageActions)
  const { params } = match
  const langcode = params.langcode ? params.langcode : 'en'

  useEffect(() => {
    languageActions.fetchLanguage(langcode, 'front', 'bookameeting')
  }, [languageActions, location])

  const { className, ...rest } = props
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <HeroAndSearchForm />
      <MiddlePart />
      <TitleList />
    </div>
  )
})

export default FrontPageBookameeting
